import { Injectable } from "@angular/core";
import { SelectItem } from "primeng/api";
import { map, Observable } from "rxjs";
import { MCCodeListWrapperService } from "@maslul/common-services";

@Injectable({
    providedIn: 'root'
})
export class EconomyService {

    constructor(private codeListService: MCCodeListWrapperService) {

    }

    uniqueProductList(): Observable<Array<SelectItem>> {
        return this.codeListService.getList("ProductListAchuda").pipe(
            map((items: SelectItem[]) => {
                const uniqueMap = new Map<string, SelectItem>();
                items.forEach(item => {
                    if (!uniqueMap.has(item.value)) {
                        uniqueMap.set(item.value, item);
                    }
                });
                return Array.from(uniqueMap.values());
            })
        );
    }
}